import cloneDeep from 'lodash.clonedeep';
import Analytics from '@/mixins/Analytics';
import {
  SET_ANALYTICS_LOGGING_ENABLED,
  SET_PUBNUB_LOGGING_ENABLED,
} from '@/store/modules/dev-tools/devTools.mutations.type';
import { getLocalStorageKeySizes, getStorageEstimate } from '@/utilities/localStorageHandler';

export const ACV_STORAGE_KEY = 'acv-storage';

export const ACV_STORAGE_MODULES = [
  'dealershipAddress',
  'featureFlags',
  'funNotifications',
  'notifications',
  'devFlags',
  'devTools',
  'uiSettings',
  'offboarding',
  'firebase',
  'capitalRouting',
  'auctionAccess',
  'marketplaceRouter',
  'marketplaceView',
  'registrationWizard',
];

const filteredMutations = new Set([
  'setExpire',
  'setFeatureFlags',
  'setAppLaunchMessage',
  'devFlags/setDevFlag',
  'setFirebaseDeviceToken',
  SET_ANALYTICS_LOGGING_ENABLED,
  SET_PUBNUB_LOGGING_ENABLED,
  'capitalRouting/setBreadcrumbsMutation',
  'capitalRouting/removeLastBreadcrumbMutation',
  'capitalRouting/clearBreadcrumbsMutation',
  'marketplaceRouter/setMarketplaceParams',
  'marketplaceRouter/setExcludedLanes',
  'marketplaceView/setDismissedSimulcastPrompt',
  'marketplaceView/setEulaReviewBannerVisible',
  'setCurrentStep',
]);

// Picks only the whitelisted modules out of the full store state
export const buildAcvStorageState = (rootState) => {
  const state = ACV_STORAGE_MODULES.reduce((acc, moduleName) => {
    acc[moduleName] = cloneDeep(rootState[moduleName]);
    return acc;
  }, {});

  delete state.featureFlags.apiClient;
  delete state.featureFlags.existingRequest;
  delete state.featureFlags.featureFlagSlugs;
  state.featureFlags.flags = state.featureFlags.fuseboxFlags; // retain only original flags
  delete state.featureFlags.fuseboxFlags;
  delete state.notifications.counts;
  delete state.notifications.notifications;
  delete state.notifications.pagination;
  delete state.devFlags.devFlagSlugs;
  delete state.uiSettings;
  delete state.auctionAccess.auctionAccessId;
  delete state.auctionAccess.last4PhotoId;
  delete state.firebase.config;
  delete state.marketplaceView.laneCategoriesToggle;
  delete state.marketplaceView.showingEventsDirectory;
  delete state.marketplaceView.searchAndFiltersTab;
  delete state.marketplaceView.canLoadVdpPandaMfe;

  return state;
};

// exported plugin which saves to local storage for app related context
const acvStoragePlugin = (store) => {
  store.subscribe(async (mutation, state) => {
    if (!filteredMutations.has(mutation.type)) return;

    const serializedState = JSON.stringify(buildAcvStorageState(state));
    try {
      window.localStorage.setItem(ACV_STORAGE_KEY, serializedState);
    } catch (e) {
      Analytics.methods.noticeError(e, {
        context: 'acvStorage.saveState',
        key: ACV_STORAGE_KEY,
        errorName: e?.name,
        writeBytes: new Blob([serializedState]).size,
        keyBytes: getLocalStorageKeySizes(),
        storageEstimate: await getStorageEstimate(),
      });
    }
  });
};

export default { plugin: acvStoragePlugin };
